import { render, staticRenderFns } from "./TiktokUserGallery.vue?vue&type=template&id=3958e1a1&scoped=true&"
import script from "./TiktokUserGallery.vue?vue&type=script&lang=ts&"
export * from "./TiktokUserGallery.vue?vue&type=script&lang=ts&"
import style0 from "./TiktokUserGallery.vue?vue&type=style&index=0&id=3958e1a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3958e1a1",
  null
  
)

export default component.exports